export interface BoostTask {
  id: string | number;
  title?: string;
  description?: string;
  icon?: string;
  provider: string;
  link?: string;
  onClick: () => Promise<'success' | 'user_cancelled' | 'ads_not_found'>;
  onShowReward?: () => Promise<boolean>;
}

export interface BoostProvider {
  getName(): string;
  getAvailableTasks(miningId: number): Promise<BoostTask[]>;
  startTask?(
    taskId: string | number,
  ): Promise<'success' | 'user_cancelled' | 'ads_not_found'>;
  resetError?(): void;
}
import { getCPCBanner, postCPCBannerClick } from '../../Requests/tasks/tasks';

interface BannerResponse {
  banner_id: string;
  title: string;
  description: string;
  image_url: string;
  link: string;
}

export class FLyerAndInnerBoostProvider implements BoostProvider {
  private static instance: FLyerAndInnerBoostProvider;
  private hasError: boolean = false;
  private lastTaskTime: number = 0;
  private readonly TASK_COOLDOWN = 5000;
  private currentBanner: BannerResponse | null = null;

  private constructor() {}

  public static getInstance(): FLyerAndInnerBoostProvider {
    if (!FLyerAndInnerBoostProvider.instance) {
      FLyerAndInnerBoostProvider.instance = new FLyerAndInnerBoostProvider();
    }
    return FLyerAndInnerBoostProvider.instance;
  }

  private canShowNewTask(): boolean {
    return Date.now() - this.lastTaskTime >= this.TASK_COOLDOWN;
  }

  private isTelegramUrl(url: string): boolean {
    return url.includes('t.me/');
  }

  async startTask(
    taskId: string | number,
  ): Promise<'success' | 'ads_not_found' | 'user_cancelled'> {
    console.log('Starting DreamCoin task with ID:', taskId);
    console.log('Current banner:', this.currentBanner);

    if (!this.canShowNewTask()) {
      console.log('Cannot start DreamCoin task: on cooldown');
      return 'ads_not_found';
    }

    try {
      if (
        !this.currentBanner ||
        this.currentBanner.banner_id.toString() !== taskId.toString()
      ) {
        console.log('Getting new banner data...');
        const response = await getCPCBanner();
        const banner = response as BannerResponse;

        if (!banner?.banner_id) {
          console.log('No valid banner data received');
          return 'ads_not_found';
        }

        this.currentBanner = banner;
      }

      if (!this.currentBanner?.link) {
        console.log('Cannot start DreamCoin task: no valid link in banner');
        return 'ads_not_found';
      }

      console.log('Opening link:', this.currentBanner.link);

      // Проверяем, является ли ссылка телеграм-ссылкой
      if (this.isTelegramUrl(this.currentBanner.link)) {
        window?.Telegram?.WebApp?.openTelegramLink(this.currentBanner.link);
      } else {
        window?.Telegram?.WebApp?.openLink(this.currentBanner.link);
      }

      // Отправляем информацию о клике
      await postCPCBannerClick(taskId as string);

      this.lastTaskTime = Date.now();
      return 'success';
    } catch (error) {
      console.error('Error starting DreamCoin task:', error);
      this.hasError = true;
      return 'ads_not_found';
    }
  }

  async getAvailableTasks(): Promise<BoostTask[]> {
    if (this.hasError) {
      return [];
    }

    const startTime = new Date().toLocaleTimeString('ru-RU', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    });

    console.log(`[${startTime}] НАЧИНАЮ ПОЛУЧАТЬ ЗАДАНИЯ DREAMCOIN`);
    try {
      const response = await getCPCBanner();
      const banner = response as BannerResponse;

      if (!banner?.banner_id) {
        console.log('No valid DreamCoin tasks found');
        return [];
      }

      // Сохраняем текущий баннер
      this.currentBanner = banner;
      console.log('Saved banner:', this.currentBanner);

      // Возвращаем только одно задание
      return [
        {
          id: `${banner.banner_id}`,
          title: banner.title || 'Просмотреть рекламу',
          description: banner.description || '',
          provider: 'DreamCoin',
          icon: banner.image_url,
          onClick: async () => {
            // При клике выполняем действие
            return this.startTask(banner.banner_id);
          },
        },
      ];
    } catch (error) {
      console.error('Error getting DreamCoin tasks:', error);
      this.hasError = true;
      return [];
    } finally {
      const EndTime = new Date().toLocaleTimeString('ru-RU', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
      });

      console.log(`[${EndTime}] ЗАВЕРШИЛ ПОЛУЧАТЬ ЗАДАНИЯ DREAMCOIN`);
    }
  }

  getName(): string {
    return 'FLyerAndInner';
  }

  resetError() {
    this.hasError = false;
    this.lastTaskTime = 0;
    this.currentBanner = null;
  }
}

// Экспортируем уже созданный экземпляр
export const fLyerAndInnerBoostProvider =
  FLyerAndInnerBoostProvider.getInstance();
